import { Backdrop, Button, Checkbox, FormControlLabel, Grid, IconButton, Switch, Typography } from '@mui/material'
import React, { Fragment, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useFormik } from 'formik';
import * as yup from 'yup';
import axios from 'axios';
import { setSnackbar } from '../../../../../components/hooks/snackBar/reducers';
import { Delete, EditNote } from '@mui/icons-material';
import _ from 'lodash';
import CustomDataGrid from '../../../../../components/dataTable/customDataGrid';
import CustomTextField from '../../../../../components/utils/input/customTextField';
import Modal from '../../../../../components/utils/modal/modal';
import DeletePage from '../../../../../components/utils/deleteModal/deletePage';
import Loader from '../../../../../components/loader/loader';
import { Helmet } from 'react-helmet-async';

const MainMenu = () => {
    const dispatch = useDispatch()
    const pageOption = [10, 25, 50, 100];
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(100);
    // const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
    const [pageCount, setPageCount] = useState(0);
    const [search, setSearch] = useState("");
    const [data, setData] = useState([])
    const [open, setOpen] = useState(false);
    const [isEdit, setIsEdit] = useState(false)
    const [openDialog, setOpenDialog] = useState(false)
    const [active, setActive] = useState(false)
    const [activeId, setActiveId] = useState(null)
    const [isLoader, setIsLoader] = useState(false); //loader


    const validationSchema = yup.object({
      menuName : yup.string().required(),
      menuUrl : yup.string().required(),
      menuOrder : yup.string().required(),
      menuIcon : yup.string().required(),
      })
      
      const formik = useFormik({
        initialValues :{
          menuName : "",
          menuUrl:"",
          menuOrder:"",
          menuIcon:""

        },
        validationSchema:validationSchema,
      onSubmit: isEdit ? handleUpdate : handleCreate
      })
      
      const onCreate = ()=>{
      setOpen(true)
      formik.resetForm()
      setIsEdit(false)
      }
      
      function handleCreate(){
        console.log("first")
        const menuData = {
          menu_name:formik.values.menuName,
          menu_url:formik.values.menuUrl,
          menu_icon:formik.values.menuIcon,
          menu_order:formik.values.menuOrder,
          company_id:1
        }
        setIsLoader(true);
        axios.post('/v1/menu', menuData)
        .then(res=>{
          console.log(res)
          setOpen(false)
          getHeadData()
          dispatch(setSnackbar(true, 'success', 'Created Successfully'))
          setIsLoader(false);
        })
        .catch(err=>{
          dispatch(setSnackbar(true, 'error',err.response.data.errors[0].message))
          console.log(err)
          setIsLoader(false);
        })
      }
      
      function onEdit(e){
      console.log(e)
      formik.setFieldValue('menuName',e.menuName)
      formik.setFieldValue('menuUrl',e.menuUrl)
      formik.setFieldValue('menuOrder' , e.menuOrder)
      formik.setFieldValue('menuIcon' , e.menuIcon)
      setIsEdit(true)
      setOpen(true)
      setActive(e.isActive)
      setActiveId(e.id)
      }
      
      function handleUpdate(){
        const menuData = {
          menu_name:formik.values.menuName,
          menu_url:formik.values.menuUrl,
          menu_icon:formik.values.menuIcon,
          menu_order:formik.values.menuOrder,
          company_id:1
        }
        setIsLoader(true);
        axios.put(`/v1/menu/${activeId}`, menuData)
        .then(res=>{
          setOpen(false)
          console.log(res)
          getHeadData()
          dispatch(setSnackbar(true, 'success', 'Updated Successfully'))
          setIsLoader(false);
        })
        .catch(err=>{
          dispatch(setSnackbar(true, 'error',err.response.data.errors[0].message))
          console.log(err)
          setIsLoader(false);
        })
      console.log('update')
      }
      
      function OnDelete(id){
        setOpenDialog(true)
        setActiveId(id)
      }  
      
      const handleDelete = () =>{
        setIsLoader(true);
        axios.delete(`/v1/menu/1/${activeId}`)
        .then(res=>{
          setOpenDialog(false)
          getHeadData()
          console.log(res)
          dispatch(setSnackbar(true, 'success', 'Deleted Successfully'))
          setIsLoader(false);
          setOpen(false)
        })
        .catch(err=>{
          dispatch(setSnackbar(true, 'error',err.response.data.errors[0].message))
          console.log(err)
          setIsLoader(false);
        })
      console.log('fasdf')
      }
      const SvgHtmlRenderer = ({ svgHtml }) => (
        <div dangerouslySetInnerHTML={{ __html: svgHtml }} />
      );
        const columns = [
          {
            field: "sno",
            headerName: "S.no",
            flex: 1,
            minWidth: 70,
            maxWidth: 100,
            headerAlign: "center",
            align: "center",
            sortable: false,
          },
          {
            field: "menuName",
            headerName: "Menu Name",
            flex: 1,
            headerAlign: "center",
            align: "center",
            sortable: false,
          },
          {
            field: "menuUrl",
            headerName: "Menu Url",
            flex: 1,
            headerAlign: "center",
            align: "center",
            sortable: false,
          },
          {
            field: "menuOrder",
            headerName: "Menu Order",
            flex: 1,
            headerAlign: "center",
            align: "center",
            sortable: false,
          },
          // {
          //   field: "menuIcon",
          //   headerName: "Menu Icon",
          //   flex: 1,
          //   headerAlign: "center",
          //   align: "center",
          //   sortable: false,
          // },
          {
            field: 'menuIcon',
            headerName: 'Menu Icon',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sortable: false,
            renderCell: (params) => <SvgHtmlRenderer svgHtml={params.row.menuIcon} />,
            // renderCell: (params) => (
            //   <div dangerouslySetInnerHTML={{ __html: params.row.menuIcon }} />
            // ),
          },
          // {
          //   field: "active",
          //   headerName: "Status",
          //   flex: 1,
          //   headerAlign: "center",
          //   align: "center",
          //   sortable: false,
          //   disableColumnMenu: true,
          //   renderCell: (params) => (
          //     <div className="">
          //       <Switch checked={params.row.isActive}/>
          //     </div>
          //   )
          // },
          {
            field: 'action',
            headerName: 'Action',
            flex: 1,
            minWidth: 100,
            headerAlign: "center",
            align: "center",
            editable: false,
            sortable: false,
            disableColumnMenu: true,
            renderCell: (params) => (
              <div className='flex justify-center w-full'>
                <IconButton onClick={()=>onEdit(params.row)} >
                  <EditNote sx={{color:"#1972d2",fontSize:22}}/>
                </IconButton>
                <IconButton onClick={() => OnDelete(params.id)}>
                  <Delete sx={{color:"red",fontSize:22}}/>
                </IconButton>
              </div>
            ),
          },
        ];
      
        const rows = _.map(data,(val,idx)=>({
          id: val.id,
          sno:++idx,
          isActive: val.is_active,
          menuName : val.menu_name,
          menuUrl:val.menu_url,
          menuOrder:val.menu_order,
          menuIcon:val.menu_icon
        }))
      
        const props = {
          rows: rows,
          columns: columns,
          search: search,
          setSearch : setSearch,
          page: page,
          setPage: setPage,
          rowsPerPage: rowsPerPage,
          setRowsPerPage: setRowsPerPage,
          pageCount: pageCount,
          pageOption: pageOption,
        };
      
      const getHeadData = () =>{
        setIsLoader(true);
        axios.get(`/v1/menu/1/${rowsPerPage}/${page + 1}`)
        .then(res=>{
          setData(res.data.data)
          setPageCount(res.data.meta.pagination.total)
          setIsLoader(false);
        })
        .catch(err=>{
          console.log(err)
          dispatch(setSnackbar(true, 'error', err.response.data.message))
          setIsLoader(false);
        })
      }
      
      useEffect(()=>{
      getHeadData()
      },[rowsPerPage, page, search])

      
  return (
    <Fragment>
      <Helmet>
        <title>Main Menu</title>
      </Helmet>
        <Typography variant='h5'>Main Menu</Typography>

        {!open &&
  <Grid className='flex justify-end'>
    <Button variant='contained' size='small' onClick={onCreate}>Create New</Button>
</Grid>}
{open &&
        <Modal onClose={setOpen}  onSave={formik.handleSubmit} formik={formik} isEdit={isEdit}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4} lg={3}>
            <CustomTextField id='menuName' value={formik.values.menuName} title='Menu Name' multiple={false} placeholder='Enter Menu Name' onchange={formik.handleChange} errorMsg={formik.touched.menuName && Boolean(formik.errors.menuName)} helperText={formik.touched.menuName && formik.errors.menuName}/>
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
            <CustomTextField id='menuUrl' value={formik.values.menuUrl} title='Menu Url' multiple={false} placeholder='Enter Menu Url' onchange={formik.handleChange} errorMsg={formik.touched.menuUrl && Boolean(formik.errors.menuUrl)} helperText={formik.touched.menuUrl && formik.errors.menuUrl}/>
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
            <CustomTextField id='menuOrder' value={formik.values.menuOrder} title='Menu Order' multiple={false} placeholder='Enter Menu Order' onchange={formik.handleChange} errorMsg={formik.touched.menuOrder && Boolean(formik.errors.menuOrder)} helperText={formik.touched.menuOrder && formik.errors.menuOrder}/>
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
            <CustomTextField id='menuIcon' value={formik.values.menuIcon} title='Menu Icon' multiple={false} placeholder='Enter Menu Icon' onchange={formik.handleChange} errorMsg={formik.touched.menuIcon && Boolean(formik.errors.menuIcon)} helperText={formik.touched.menuIcon && formik.errors.menuIcon}/>
            </Grid>
            <Grid item xs={12} md={4} lg={3} className="flex items-center">
            <FormControlLabel  control={<Checkbox checked={active} onChange={()=>setActive(!active)}/>} label="Active" />
            </Grid>
            
          </Grid>
        </Modal>
      }
      <Grid className="bg-white rounded-md p-2 my-3">
        <CustomDataGrid props={props} />
      </Grid>
      <Backdrop open={openDialog} sx={{zIndex:1350}}>
  <DeletePage onCancel={setOpenDialog} onSubmit={handleDelete}/>
</Backdrop>
{/* <Loader isLoader={isLoader}/> */}
    </Fragment>
  )
}

export default MainMenu